<template>
	<v-app theme="dark" style="background-color: #eeeeee">
		<v-main>
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12 primary white--text">
							<v-toolbar-title>
								<v-img
									class="mx-auto mt-5"
									alt="Orixe Logo"
									:src="require('../../assets/Logo_Header_White.svg')"
									width="40%"
								/>
								<h1 class="mt-2 ml-5 white--text text-left">Recover Your Account</h1>
							</v-toolbar-title>
							<v-form @submit.prevent="sendForgot">
								<v-alert
									type="error"
									v-if="$store.getters['user/authStatus'] == 'error'"
								>{{$store.state.user.error}}</v-alert>
								<v-card-text>
									<v-text-field
										label="E-mail"
										v-model="email"
										name="email"
										prepend-icon="fas fa-envelope"
										type="text"
										dark
									></v-text-field>
								</v-card-text>
								<v-card-actions>
									<v-btn outlined  color="white" to="/login" class="ma-3"><i class="fa fa-fw fa-arrow-left"></i>Back to login</v-btn>
									<v-spacer></v-spacer>
									<v-btn type="submit" color="secondary" class="ma-3">Reset Password</v-btn>
								</v-card-actions>
							</v-form>
						</v-card>
					</v-col>
				</v-row>
			</v-container>

			<v-snackbar v-model="displayAlertMessage" bottom color="primary">
				{{alertMessage}}
				<template v-slot:action="{ attrs }">
					<v-btn dark text v-bind="attrs" @click="alertMessage = null">Close</v-btn>
				</template>
			</v-snackbar>
		</v-main>
		<test-error />
	</v-app>
</template>

<script>
import store from "../../store"
export default {
	name: "Forgot",
	data() {
		return {
			email: null,
			alertMessage: null,
		}
	},
	computed: {
		displayAlertMessage() {
			return !!this.alertMessage
		}
	},
	methods: {
		sendForgot: async function () {
			let email = this.email
			let loginpromise = store.dispatch("user/forgotPassword", {
				email,
			})
			let that = this
			loginpromise
				.then(function () {
					that.email = null
					that.alertMessage = "If an account with this email exists, an email was sent with instructions on how to recover your account."
				})
				.catch((err) => console.log(err))
		},
	},
}
</script>